<template>
<div class="chapter">
<div class="inner_page">
<p class="center" id="ded">For Harry Scott Gibbons<br/>and<br/>Charles David Bravos Gibbons</p>
<p class="center">With love.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780795310959_epub_ded_r1.vue?a3fa6c56